import Icon from 'antd/lib/icon'
import styled from 'styled-components'

interface RowProps {
  secondary?: boolean
  index?: number
}

export const BottomSheetWrapper = styled.div`
  z-index: 8;
  transition: all .25s;
  .react-swipeable-view-container {
    box-shadow: rgba(0, 0, 0, 0.157) 0px -1px 5px !important;
  }
  ${({ secondary }: RowProps) => secondary ? `
    .react-swipeable-view-container > div {
      margin-bottom: 0px !important;
    }
  ` : ''}
`

export const StyledTitle = styled.div`
  background-color: #f6f6f6;
  padding: 10px 18px;
  box-sizing: border-box;
  cursor: pointer;
  color: #0f68d0;
  letter-spacing: 0.23px;
  text-align: center;
  top: -32px;
  position: absolute;
  font-size: 15px;
  font-family: Avenir;
  font-weight: normal;
  left: calc(50vw - 78px);
  display: flex;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0px -4px 6px -5px #9d9d9d;
`

export const ProductListContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  flex-wrap: wrap;
  align-items: flex-start;
  background: #f6f6f6;
  @media (max-width: 698px) {
    ${({ secondary }: RowProps) => secondary ? `
    height: calc(100vh - 310px);
    overflow-y: scroll;
    background: white;
  ` : ''}
  }
`

export const CollapseButton = styled(Icon)`
  margin-left: 10px;
  padding-right: 12px;
  color: gray;
`

export const ThumbnailListItem = styled.li`
  list-style: none;
  width: fit-content;
  margin-right: 42px;
  &:last-child {
    margin-right: 0px;
  }
  @media (max-width: 698px) {
    margin-right: 0px;
  }
  animation: scale-in-center 0.1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 
    ${({ index }: RowProps) => `${index ? (index * 0.1) : '1'}s`} both;
  @keyframes scale-in-center {
    0% {
      transform: scale(0.95);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ShoppingCartPage/RecommendationIsland/styledComponents.tsx